<template lang="html">
  <div class="content-bg simple-form">
    <Field
      :isPreviewing="true"
      label="Name"
      type="text"
    />

    <Field
      :isPreviewing="true"
      label="Email Address"
      type="email"
    />

    <p>
      <em>Please note: The "Name" and "Email Address" fields are default. You will not need to create these.</em>
    </p>

    <hr>

    <div v-for="item in items" :key="item.id">
      <Field
        :isPreviewing="true"
        :label="parse(item).label"
        :type="fieldType(parse(item).field_type)"
        :placeholder="parse(item).placeholder"
        :options="selectOptions(parse(item).dropdown_options)"
        :disableEditor="true"
        :value="isChecked(parse(item))"
      />
    </div>

    <Btn class="is-dark">Send Message</Btn>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

import Field from '@/components/Field'
import Btn from '@/components/Btn'

export default {
  name: 'SimpleForm',

  mixins: [parseComponent],

  components: {
    Field,
    Btn
  },

  computed: {
    fieldType() {
      return (type) => {
        return type.replace('form-', '')
      }
    },

    isChecked() {
      return (field) => {
        let isCheckbox = field.field_type === 'form-checkbox'

        if (isCheckbox) {
          return !!(field.automatically_checked === 'true')
        } else {
          return ''
        }
      }
    },

    selectOptions() {
      return (options) => {
        if (options) {
          let array = []

          let newOptions = options.split(',')

          newOptions.forEach((option) => {
            array.push({key: option, value: option})
          })

          return array
        }
      }
    }
  },

  props: {
    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  }
}
</script>

<style lang="sass">
.simple-form
  .input
    .code-textarea
      font-family: arial
      height: 200px

    &.is-checkbox
      input
        text-align: left

  .btn
    margin: 0 auto 30px
    display: block
    padding: 15px 25px
</style>
